import {getBeginLocalStr, getBeginStr, getEndLocalStr, getEndStr} from "../../../core/utils/date-utils";

/**
 * Rapor grid filtresini sunucuya gönderilecek hale getirir.
 *
 * TEK KAYNAK: grid, sayaç (ReportGrid) ve Excel (ReportGridTools) AYNI fonksiyondan geçer.
 * Eskiden normalizasyon yalnızca ReportGrid.initDataGrid içindeydi; Excel context'teki HAM
 * queryModel'i (moment nesneleri, seçim anının saatiyle) gönderdiği için gridle farklı bir
 * tarih aralığı sorgulanıyor ve iki taraf farklı sayı üretiyordu.
 *
 * Rapor/imza tarihi UTC'ye çevrilir; çekim tarihi sunucuda duvar saati olduğu için kaydırılmaz
 * (bkz. date-utils).
 */
export const normalizeReportFilter = (filter) => ({
    ...filter,
    reportDateBegin: getBeginStr(filter?.reportDateBegin),
    reportDateEnd: getEndStr(filter?.reportDateEnd),
    studyDateBegin: getBeginLocalStr(filter?.studyDateBegin),
    studyDateEnd: getEndLocalStr(filter?.studyDateEnd),
    signDateBegin: getBeginStr(filter?.signDateBegin),
    signDateEnd: getEndStr(filter?.signDateEnd),
});

/** Grid'in query model'ini (filtre + sayfalama + sıralama) gönderilebilir hale getirir. */
export const toReportGridQuery = (queryModel) => ({
    ...queryModel,
    filter: normalizeReportFilter(queryModel?.filter),
});
